var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index mdc-layout-grid mdc-container pt-5 mt-5",attrs:{"id":"index"}},[_vm._v(" Prima pagina ")])}
var staticRenderFns = []

export { render, staticRenderFns }